import priceService from '../../services/priceService';

/**
 * Price mixin
 *
 * @var {Object}
 */
export default {
    filters: {
        /**
         * Get formatted price
         *
         * @param {int|float} value
         *
         * @return {string}
         */
        price(value) {
            return priceService.getFormattedPrice(value);
        }
    }
};